import { RecalProposalSetConstant, recalProposalSetDtlRequiredFieldList } from "presentation/constant/RecalProposalSet/RecalProposalSetConstant";
import { useRecalProposalSetVM } from "presentation/hook/RecalProposalSet/useRecalProposalSetVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useRecalProposalSetTracked } from "presentation/store/RecalProposalSet/RecalProposalSetProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const RecalProposalSetDtlEditPanel = () => {
    const RECAL_PROPOSAL_SET_CONSTANT = RecalProposalSetConstant.DtlTable;
    const [recalProposalSetState] = useRecalProposalSetTracked();
    const recalProposalSetVM = useRecalProposalSetVM();
    const { isShowDtlAddPanel, isShowDtlEditPanel, currentDtlEditRow, companyList, masterState } = recalProposalSetState;
    const { isSaveClicked, allFormState } = masterState;
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    // const messageBarVM = useMessageBarVM();

    const memoProposalNoOptions = useMemo(() => {
        return currentDtlEditRow.companyCode
            ? recalProposalSetState.dynamicOptions.proposalNoDropdownOptions[companyList[currentDtlEditRow.companyCode] ? companyList[currentDtlEditRow.companyCode][0]?.id : '']
            : [];
    }, [currentDtlEditRow.companyCode, recalProposalSetState.dynamicOptions.proposalNoDropdownOptions, companyList]);



    const handleSave = useCallback(async () => {
        // if (!currentDtlEditRow.companyCode) {
        //     messageBarVM.showError("Company Code is mandatory.");
        //     return;
        // }
        // if (!currentDtlEditRow.proposalNo) {
        //     messageBarVM.showError("Proposal No is mandatory.");
        //     return;
        // }
        recalProposalSetVM.onSaveClicked();
        recalProposalSetVM.onDtlTempSave(currentDtlEditRow);
    }, [recalProposalSetVM, currentDtlEditRow]);

    const handClose = useCallback(() => {
        recalProposalSetVM.onCloseDtlEidtPanel();
    }, [recalProposalSetVM]);

    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={''}
                fieldValue={currentDtlEditRow?.companyCode}
                fieldLabel={RECAL_PROPOSAL_SET_CONSTANT.COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={recalProposalSetState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={recalProposalSetDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProposalSetVM.onDtlFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentDtlEditRow?.companyCode, RECAL_PROPOSAL_SET_CONSTANT.COMPANY_CODE, isSaveClicked, recalProposalSetState.dynamicOptions.companyCodeDropdownOptions, recalProposalSetVM])

    const memoCompanyType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentDtlEditRow?.companyType ?? ''}
                fieldValue={currentDtlEditRow?.companyType}
                fieldLabel={RECAL_PROPOSAL_SET_CONSTANT.COMPANY_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'companyType'}
                requiredFieldList={[]}
                maxLength={60}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProposalSetVM.onDtlFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentDtlEditRow?.companyType, RECAL_PROPOSAL_SET_CONSTANT.COMPANY_TYPE, isSaveClicked, recalProposalSetVM])

    const memoProposalNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={''}
                fieldValue={currentDtlEditRow?.proposalNo}
                fieldLabel={RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'proposalNo'}
                maxLength={60}
                options={memoProposalNoOptions}
                requiredFieldList={recalProposalSetDtlRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProposalSetVM.onDtlFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentDtlEditRow?.proposalNo, RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_NO, isSaveClicked, memoProposalNoOptions, recalProposalSetVM])

    const memoCreatedBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentDtlEditRow?.createdBy ?? ''}
                fieldValue={currentDtlEditRow?.createdBy}
                fieldLabel={RECAL_PROPOSAL_SET_CONSTANT.CREATED_BY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'createdBy'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProposalSetVM.onDtlFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [allFormState, currentDtlEditRow?.createdBy, RECAL_PROPOSAL_SET_CONSTANT.CREATED_BY, isSaveClicked, recalProposalSetVM])

    const memoEffectiveDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={true}
                label={RECAL_PROPOSAL_SET_CONSTANT.EFFECTIVE_DATE}
                width="150px"
                date={currentDtlEditRow?.effectiveDate}
                fieldName="effectiveDate"
                onDateChange={() => { }} />
        </div>
        , [RECAL_PROPOSAL_SET_CONSTANT.EFFECTIVE_DATE, currentDtlEditRow?.effectiveDate])

    const memoExpiry = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={true}
                label={RECAL_PROPOSAL_SET_CONSTANT.EXPIRY_DATE}
                width="150px"
                date={currentDtlEditRow?.expiryDate}
                fieldName="expiryDate"
                onDateChange={() => { }} />
        </div>
        , [RECAL_PROPOSAL_SET_CONSTANT.EXPIRY_DATE, currentDtlEditRow?.expiryDate])

    const memoCreatedDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={true}
                label={RECAL_PROPOSAL_SET_CONSTANT.CREATED_DATE}
                width="150px"
                date={currentDtlEditRow?.createdDateTime}
                fieldName="createdDateTime"
                onDateChange={() => { }} />
        </div>
        , [RECAL_PROPOSAL_SET_CONSTANT.CREATED_DATE, currentDtlEditRow?.createdDateTime])


    return <>
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 20px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
                        <Sidebarheader style={{ width: '100%' }}>
                            <SidebarTitle>
                                {isShowDtlAddPanel && "New Proposal Set Company"}
                                {isShowDtlEditPanel && "Edit Proposal Set Company"}
                            </SidebarTitle>
                            <SidebarActionCross>
                                <>
                                    <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                                    <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                                </>
                            </SidebarActionCross>

                        </Sidebarheader>

                    </StyledSidebar>
                </div>
            </div>
            <div className={'add-edit-form'} style={{ height: '78vh', maxHeight: '78vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        <CriteriaItemContainer>
                            {memoCompanyCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoCompanyType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoProposalNo}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoEffectiveDate}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {(operatingUnit === 'SAPT' || operatingUnit === 'KICT') && memoExpiry}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoCreatedBy}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoCreatedDate}
                        </CriteriaItemContainer>



                    </div>
                </div>
            </div>

        </div>
    </>
}

export default memo(RecalProposalSetDtlEditPanel);
